// Level Configuration System
// This allows admins to customize XP requirements for each level

// Default level configuration
export const DEFAULT_LEVEL_CONFIG = {
  levels: [
    { level: 1, pointsRequired: 0 }, // Starting level
    { level: 2, pointsRequired: 50 },
    { level: 3, pointsRequired: 150 },
    { level: 4, pointsRequired: 300 },
    { level: 5, pointsRequired: 500 },
    { level: 6, pointsRequired: 750 },
    { level: 7, pointsRequired: 1050 },
    { level: 8, pointsRequired: 1400 },
    { level: 9, pointsRequired: 1800 },
    { level: 10, pointsRequired: 2250 },
    { level: 11, pointsRequired: 2750 },
  ],
  maxLevel: 50,
  pointsPerLevelAfter: 500, // Points required for each level after the configured ones
  baseLevel: 10, // Level after which the pointsPerLevelAfter applies
}

// Get current level configuration from localStorage or use default
export const getLevelConfig = () => {
  try {
    const saved = localStorage.getItem("levelConfig")
    if (saved) {
      const parsed = JSON.parse(saved)
      // Validate the structure
      if (parsed.levels && Array.isArray(parsed.levels) && parsed.maxLevel) {
        return parsed
      }
    }
  } catch (error) {
  }

  return DEFAULT_LEVEL_CONFIG
}

// Save level configuration to localStorage
export const saveLevelConfig = (config) => {
  try {
    localStorage.setItem("levelConfig", JSON.stringify(config))
    return true
  } catch (error) {
    return false
  }
}

// Reset level configuration to defaults
export const resetLevelConfig = () => {
  try {
    localStorage.removeItem("levelConfig")
    return true
  } catch (error) {
    return false
  }
}

// Validate level configuration
export const validateLevelConfig = (config) => {
  if (!config || typeof config !== "object") {
    return { valid: false, error: "Config must be an object" }
  }

  if (!Array.isArray(config.levels)) {
    return { valid: false, error: "Levels must be an array" }
  }

  if (config.levels.length === 0) {
    return { valid: false, error: "Must have at least one level" }
  }

  // Check that levels are in order and have required fields
  for (let i = 0; i < config.levels.length; i++) {
    const level = config.levels[i]
    if (!level.level || !Number.isInteger(level.level) || level.level < 1) {
      return {
        valid: false,
        error: `Level ${i + 1} must have a valid level number`,
      }
    }

    if (typeof level.pointsRequired !== "number" || level.pointsRequired < 0) {
      return {
        valid: false,
        error: `Level ${level.level} must have valid points required`,
      }
    }

    // Check ordering
    if (i > 0 && level.pointsRequired <= config.levels[i - 1].pointsRequired) {
      return {
        valid: false,
        error: `Level ${level.level} must require more points than previous level`,
      }
    }
  }

  if (!Number.isInteger(config.maxLevel) || config.maxLevel < 1) {
    return { valid: false, error: "Max level must be a positive integer" }
  }

  return { valid: true }
}
